import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import { Collapse, Checkbox, FormControlLabel, IconButton } from '@material-ui/core';
import { FaCogs } from 'react-icons/fa';

import API from 'utils/api';
import { useDelay } from 'hooks';
import { classes } from 'utils';
import { Tooltip } from 'components';

import styles from './ChatSettings.module.scss';

const ChatSettings = ({ event }) => {
  const [open, setOpen] = useState(false);
  const [editable, setEditable] = useState(!!_.get(event, 'game.editable'));

  const visible = useDelay(open ? 0 : 200, open, false);

  useEffect(() => {
    setEditable(!!_.get(event, 'game.editable'));
  }, [event]);

  return (
    <div className={styles.chatSettings}>
      <div className={styles.header}>
        <IconButton color="primary" onClick={() => setOpen(x => !x)}>
          <Tooltip title="Show live chat settings" placement="top">
            <FaCogs />
          </Tooltip>
        </IconButton>
      </div>

      <Collapse in={visible} timeout={200}>
        <div className={classes(styles.body, open ? styles.visible : styles.hidden)}>
          <div className={styles.wrapper}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={editable}
                  onChange={e => {
                    setEditable(e.target.checked);
                    API.editGame(event._id, { editable: e.target.checked });
                  }}
                  color="primary"
                />
              }
              label="Enable manual game update"
            />
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default ChatSettings;
